/* Sandbar story pages: scroll reveal, parallax, pinned-layer zoom, count-up. No dependencies.
   Content is always in the HTML; this only adds motion. Honours prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__sbStory) return; window.__sbStory = true;
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in w;

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }

  /* 1. Reveal on scroll */
  var REVEAL = [
    '.sb-split__text > *', '.sb-split__media', '.sb-letter__body > *', '.sb-pillars li',
    '.sb-scoll__card', '.sb-layer__card', '.sb-qa', '.sb-faqx__head > *', '.sb-mgoal__row > *',
    '.sb-mgoal .sb-goal', '.sb-mjoin__text > *', '.sb-mjoin__form', '.sb-mfacts__grid li', '.sb-headrow', '.sb-step'
  ].join(',');

  function setupReveal() {
    if (reduce || !hasIO || d.visibilityState === 'hidden') return;
    var els = d.querySelectorAll(REVEAL);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('sb-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) {
      if (el.closest('.sb-shero')) return;
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--sb-delay', Math.min(sibs, 5) * 90 + 'ms');
      el.classList.add('sb-rv');
      io.observe(el);
    });
    d.documentElement.classList.add('sb-motion');
  }

  /* 2. Count-up for figures like 52%, 300m, 100+ */
  function countFig(node) {
    var m = (node.textContent || '').trim().match(/^([^\d]*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if (!m || /[A-Za-z]/.test(m[1])) return;
    var raw = m[2].replace(/,/g, ''), end = parseFloat(raw);
    if (!(end >= 10) || /^(19|20)\d\d$/.test(raw)) return;
    var dec = (raw.split('.')[1] || '').length, commas = m[2].indexOf(',') > -1 || end >= 10000;
    var t0 = null, dur = 1400;
    function f(v) { var s = v.toFixed(dec); return commas ? Number(s).toLocaleString('en-GB', { minimumFractionDigits: dec, maximumFractionDigits: dec }) : s; }
    function step(t) {
      if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      node.textContent = m[1] + f(end * e) + m[3];
      if (p < 1) requestAnimationFrame(step);
    }
    node.textContent = m[1] + f(0) + m[3];
    requestAnimationFrame(step);
  }
  function setupCount() {
    if (reduce || !hasIO) return;
    Array.prototype.forEach.call(d.querySelectorAll('[data-sb-num]'), function (n) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countFig(n); io.disconnect(); } }); }, { threshold: 0.6 });
      io.observe(n);
    });
  }

  /* 3. Parallax: chapter images drift, inset photos drift faster, pinned layers ease in */
  function setupParallax() {
    if (reduce) return;
    var drift = d.querySelectorAll('.sb-split__frame img, .sb-split__inset');
    var layers = d.querySelectorAll('.sb-layer');
    if (!drift.length && !layers.length) return;
    var ticking = false, vh = w.innerHeight;
    function update() {
      ticking = false;
      Array.prototype.forEach.call(drift, function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var c = (r.top + r.height / 2 - vh / 2) / vh;
        var amt = el.classList.contains('sb-split__inset') ? -90 : -36;
        el.style.setProperty('--sb-py', (c * amt).toFixed(1) + 'px');
      });
      Array.prototype.forEach.call(layers, function (s) {
        var r = s.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - vh)));
        s.style.setProperty('--sb-p', p.toFixed(3));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', function () { vh = w.innerHeight; onScroll(); });
    update();
  }

  /* 4. FAQ: one answer open at a time */
  function setupFaq() {
    Array.prototype.forEach.call(d.querySelectorAll('.sb-faqx__list'), function (list) {
      list.addEventListener('toggle', function (e) {
        var t = e.target; if (!t.open) return;
        Array.prototype.forEach.call(list.querySelectorAll('details[open]'), function (o) { if (o !== t) o.open = false; });
      }, true);
    });
  }

  function safety() {
    setTimeout(function () {
      Array.prototype.forEach.call(d.querySelectorAll('.sb-rv:not(.sb-in)'), function (el) {
        if (el.getBoundingClientRect().top < w.innerHeight) el.classList.add('sb-in');
      });
    }, 2500);
  }

  ready(function () { setupReveal(); setupCount(); setupParallax(); setupFaq(); });
  w.addEventListener('load', safety);
})();
